import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-preview-document',
  templateUrl: './preview-document.component.html',
  styleUrls: ['./preview-document.component.css']
})
export class PreviewDocumentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
